export const useDefaultData = ({ Helpers }) => {

    const { getCurrentDate, getCurrentStartMonth } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFilterForm = {
        startDate: getCurrentStartMonth(),
        endDate: getCurrentDate(),
        idbanco: 'ALL',
    }

    const defaultFormScreen = {
        id: '',
        idbanco: '',
        origen: '',
        fecha: '',
        monto: '',
        moneda: '',
        tipo_cambio: '',
        quetzales: '',
        dolares: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_check: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        observaciones: '',
        usuario_creo: '',
        fecha_creo: '',
        usuario_modifico: '',
        fecha_modifico: '',
    }

    const defaultFilterMovements = {
        startDate: getCurrentStartMonth(),
        endDate: getCurrentDate(),
        idbanco: 'ALL',
        movimiento_tipo: 'ALL',
    }

    const defaultFormMovement = {
        idbanco: '',
        movimiento_fecha: getCurrentDate(),
        movimiento_tipo: '',
        movimiento_monto: '',
        movimiento_moneda: '',
        movimiento_tipo_cambio: '7.80',
        movimiento_quetzales: '',
        movimiento_dolares: '',
        movimiento_observaciones: '',
        boleta_numero: '',
        aprobacion_referencia_ach: '',
        boleta_foto_originalname: '',
        boleta_foto_path: '',
        acceptedFiles: [],
        fileRejections: [],

        clean_movimiento_monto: 0,
        clean_movimiento_tipo_cambio: 7.8,
        clean_movimiento_quetzales: 0,
        clean_movimiento_dolares: 0,
    }

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ]

    return Object.freeze({
        defaultDataModal,
        defaultFilterForm,
        defaultFormScreen,
        defaultFilterMovements,
        defaultFormMovement,
        optionsAprobacionDeposit,
    })
}
